module.exports = __webpack_public_path__ + "static/media/lupabanner.5bbd5c4f.png";